import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { DividendAccrualTable } from '../../../../../../../../../../features/mutual-funds/dividend-accrual/dividend-accrual-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsMutualfunds,
      label: 'Dividend Accruals',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsMutualfunds>,
  head: () => getPageHead('Mutual Funds Dividend Accruals'),
  component: MutualfundsDividendsAccrualsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsMutualfunds}
    />
  );
}

function MutualfundsDividendsAccrualsList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <DividendAccrualTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
